import { useEffect } from 'react';
import { useAuth } from '@restworld/feature-authentication';
import { clearOpenObserveUser, identifyOpenObserveUser } from '../observability/identify-openobserve-user';
import { useMeasurementConsent } from './use-measurement-consent';

/**
 * Attach the logged-in user to the OpenObserve RUM session, the counterpart of the PostHog
 * identify in usePostHogProvider.
 *
 * Same gate as PostHog: the user's personal data (email, name, phone) is attached only with
 * the Iubenda Measurement purpose. Without it, or once the user logs out, the session stays
 * anonymous. Unlike PostHog, which keeps the person until reset(), the user is cleared
 * explicitly, so whoever uses the tab next is not recorded under the previous account.
 */
export function useOpenObserveIdentify(): void {
  const { user, isAuthenticated } = useAuth();
  const measurementConsent = useMeasurementConsent();

  useEffect(() => {
    if (isAuthenticated && user && measurementConsent) {
      identifyOpenObserveUser(user);
    } else {
      clearOpenObserveUser();
    }
  }, [isAuthenticated, user, measurementConsent]);
}
